export default "__VITE_ASSET__pFHXAbB2__";